export class SearchResultLabel_EN {
    searchResult: {
        quotationFor: string;
        atText: string;
        acceptTermLine1: string;
        acceptTermLine2: string;
        acceptTermLine3: string;
        acceptTermLine4: string;
        acceptTermLine5: string;
    }

    constructor() {
        this.searchResult = {
            quotationFor: "Quotation for",
            atText: "at",
            acceptTermLine1: "I Accept the Terms of use . I am explicitly soliciting a call/SMS on my mobile & am allowing this information to be used by Nissan Finance & its partners to customize car loan offerings to my profile in accordance with the privacy policy . This consent will override any DNC / NDNC registration.",
            acceptTermLine2: "The loan process would be subject to terms and conditions.",
            acceptTermLine3: "As you explore the finance offers, the EMI calculations available on the platform provides the tentative EMI that you will have to pay. Figures are indicative and not final to give a good idea of how much the loan will cost you.",
            acceptTermLine4: "Credit decision is at sole discretion of Nissan Finance.",
            acceptTermLine5: "Final Credit approval is subject to change basis the internal policy of Nissan Finance."
        }
    }
}